import getLinkText from "../../../helpers/getLinkText";
import { trackEvent } from "../../../trackEvent";

/**
 * Push any header links to datalayer when they are in the .header tag
 * Basic DOM markup assumed.
 * 
 * <div class="header">
 *  <div data-gtm-subsection="social">
 *   <a href="">Facebook</a>
 *  </div>
 * </div>
 */

const test = ({ target }) => target.closest("nav.header");

const push = ({ link, target }) => {
  trackEvent({
    event: "click_menu",
    element_text: getLinkText({ link, target }),
    element_url: link,
    event_type: "click"
  });
}

export default {
  name: "header",
  test,
  push
};